import { useEffect, useMemo, useState } from "react";
import { useAssistants } from "../Assistants";

import { CAMPAIGN_TYPE } from "./SingleContact";

function useAllAssistantOptions(assistants) {
  const [assistantId, setAssistantId] = useState("");

  const assistantOptions = useMemo(() => {
    const defaultOption = {
      id: 0,
      label: "Please select assistant",
      value: "",
    };

    if (assistants) {
      const filteredAssistantsByCampaignType = assistants.filter((assistant) =>
        Boolean(["sms", "voice", "whatsapp"].includes(assistant.assistantType))
      );

      const filteredAssistantOptions = filteredAssistantsByCampaignType.map(
        (_assistant, idx) => {
          return {
            id: idx + 1,
            label: _assistant.name,
            value: _assistant._id,
          };
        }
      );

      return [defaultOption, ...filteredAssistantOptions];
    }

    return [defaultOption];
  }, [assistants]);

  return {
    assistantOptions,
    assistantId,
    setAssistantId,
  };
}

export { useAllAssistantOptions };
